import {
  BatchUpload,
  ChangeBranch,
  Home,
  SuspendStaff,
  ViewStaff,
  StaffTransactionHistory,
} from "../pages";
import AttendanceHistory from "../pages/Admin/Attendance/history";
import AttendanceHome from "../pages/Admin/Attendance/home";
import MemberAttendanceHistory from "../pages/Admin/Attendance/MemberAttendanceHistory";
import AutomatedBirthdayHome from "../pages/Admin/AutomatedBirthday/Home";
import SettingBranch from "../pages/Admin/Configuration&Settings/Branch";
import MemberSlotCapacity from "../pages/Admin/Configuration&Settings/MemberSlotCapacity";
import CompanyPrefix from "../pages/Admin/Configuration&Settings/CompanyPrefix";
import EditCompanyPrefix from "../pages/Admin/Configuration&Settings/EditCompanyPrefix";
import SettingEditBranch from "../pages/Admin/Configuration&Settings/Editbranch";
import SettingEditNewRegistrationFee from "../pages/Admin/Configuration&Settings/EditMemberRegistrationFee";
import FineSettings from "../pages/Admin/Configuration&Settings/FineSettings";
import NewFine from "../pages/Admin/Configuration&Settings/NewFine";
import EditFine from "../pages/Admin/Configuration&Settings/EditFine";
import ConfigurationHome from "../pages/Admin/Configuration&Settings/Home";
import SettingsIndexRedirect from "../pages/Admin/Configuration&Settings/SettingsIndexRedirect";
import LoanApplicationSetting from "../pages/Admin/Configuration&Settings/LoanApplicationSetting";
import SupportSettings from "../pages/Admin/Configuration&Settings/SupportSettings";
import SettingMemberRegistrationFee from "../pages/Admin/Configuration&Settings/MemberRegistrationFee";
import SettingRoleManagement from "../pages/Admin/Configuration&Settings/RoleManagement";
import NewRole from "../pages/Admin/Configuration&Settings/NewRole";
import EditRole from "../pages/Admin/Configuration&Settings/EditRole";
import SocietyBankInfo from "../pages/Admin/Configuration&Settings/SocietyBankInfo";
import NewBankInfo from "../pages/Admin/Configuration&Settings/NewBankInfo";
import Contribution_History from "../pages/Admin/Contribution/Contribution_History";
import Contribution_HistoryV2 from "../pages/Admin/Contribution/Contribution_HistoryV2";
import Contribution_HistoryDetail from "../pages/Admin/Contribution/Contribution_HistoryDetail";
import Create_Contribution from "../pages/Admin/Contribution/contribution-category";
// import Record_Contribution from "../pages/Admin/Contribution/Record_Contribution";
import Record_ContributionMain from "../pages/Admin/Contribution/Record_ContributionMain";
import WithdrawalRequests from "../pages/Admin/Contribution/WithdrawalRequests";
import BranchSettlementWallet from "../pages/Admin/BranchWallet/BranchSettlementWallet";
import BankTransferConfirmations from "../pages/Admin/Payments/BankTransferConfirmations";
import OnlinePendingPayments from "../pages/Admin/Payments/OnlinePendingPayments";
import EventCalendarCreate from "../pages/Admin/EventCalendar/create";
import EditEventCalendar from "../pages/Admin/EventCalendar/EditEventCalendar";
import EventCalendar from "../pages/Admin/EventCalendar/Home";
import LoanRepayment from "../pages/Admin/LoanManagement/LoanRepayment";
import LoanRepaymentRecord from "../pages/Admin/LoanManagement/LoanRepaymentRecord";
import LoanStatus from "../pages/Admin/LoanManagement/LoanStatus";
import NewApplication from "../pages/Admin/LoanManagement/NewApplication";
import AdminLoanCalculator from "../pages/Admin/LoanManagement/AdminLoanCalculator";
import RecordExistingLoan from "../pages/Admin/LoanManagement/RecordExistingLoan";
import RecordExistingLoanNew from "../pages/Admin/LoanManagement/RecordExistingLoanNew";
import RecordExistingLoanDetail from "../pages/Admin/LoanManagement/RecordExistingLoanDetail";

// import RecordLoanRepayment from "../pages/Admin/LoanManagement/SearchLoanRepaymentByMember";
import {
  ChangeBranchMember,
  MemberBatchUpload,
  ViewSingleMember,
  MemberHistory,
} from "../pages/Admin/MemberRegistration";
import MemberRegHome from "../pages/Admin/MemberRegistration/Home";
import PendingMember from "../pages/Admin/MemberRegistration/PendingMember";
import SuspendMember from "../pages/Admin/MemberRegistration/SuspendMember";
import UpdateMember from "../pages/Admin/MemberRegistration/UpdateMember";
import ViewMembers from "../pages/Admin/MemberRegistration/ViewMembers";
import ArchivedMembers from "../pages/Admin/MemberRegistration/ArchivedMembers";
import MemberExitRequests from "../pages/Admin/MemberRegistration/MemberExitRequests";
import ExitedMembers from "../pages/Admin/MemberRegistration/ExitedMembers";
import { StaffRegistrationHome } from "../pages/Admin/StaffRegistration/Home";
import { EditStaff } from "../pages/Admin/StaffRegistration/EditStaff";
import { ViewSingleStaff } from "../pages/Admin/StaffRegistration/ViewSingleStaff";
import MemberAttendance from "../pages/Members/Attendance/Attendance";
import MemberContribution from "../pages/Members/Contribution/Contribution";
import MemberCreateContribution from "../pages/Members/Contribution/CreateContribution";
import MemberLateContribution from "../pages/Members/Contribution/LateContribution";
import MemberUpcomingContribution from "../pages/Members/Contribution/UpcomingContribution";
import RecordContribution from "../pages/Members/Contribution/RecordContribution";
import PaymentConfirmation from "../pages/Members/Contribution/PaymentConfirmation";
import AlatpayCheckout from "../pages/Members/Contribution/AlatpayCheckout";
import MemberTransactionHistory from "../pages/Members/TransactionHistory/TransactionHistory";
import MemberEvent from "../pages/Members/Event/Event";
import {
  MemberEminutesList,
  MemberEminuteDetail,
} from "../pages/Members/Eminute";
import {
  Communication as MemberCommunication,
  MessageDetail as MemberCommunicationDetail,
} from "../pages/Members/Communication";
import MemberSupport from "../pages/Members/Support/Support";
import MemberHome from "../pages/Members/Home";
import MemberBirthdays from "../pages/Members/Birthday/MemberBirthdays";
import MemberProfile from "../pages/Members/Profile/MemberProfile";
import EditMemberProfile from "../pages/Members/Profile/EditMemberProfile";
import LoanApplication from "../pages/Members/LoanManagement/LoanApplication";
import LoanManagement from "../pages/Members/LoanManagement/LoanManagement";
import LoanCalculationResult from "../pages/Members/LoanManagement/LoanCalculationResult";
import MemberLoanRepayment from "../pages/Members/LoanManagement/LoanRepayment";
import MemberLoanRepaymentBreakdown from "../pages/Members/LoanManagement/MemberLoanRepaymentBreakdown";
import MemberLoanRepaymentPay from "../pages/Members/LoanManagement/MemberLoanRepaymentPay";
import MemberLoanStatus from "../pages/Members/LoanManagement/LoanStatus";
import GuarantorRequests from "../pages/Members/LoanManagement/GuarantorRequests";
import { EminuteHome, NewEminute, EminutePage } from "../pages/Admin/Eminute";
import {
  Summary as CommunicationSummary,
  GroupManagement,
  ViewGroup,
  AddMembersToGroup,
  Communications,
  MessageDetail as CommunicationMessageDetail,
} from "../pages/Admin/Communication";
import StaffProfile from "../pages/Admin/Profile/StaffProfile";
import LoanType from "../pages/Admin/LoanManagement/LoanType";
// import RepaymentSettings from "../pages/Admin/LoanManagement/LoanRepaymentByMemberSearchPage";
// import LoanRepaymentMemberBreakdown from "../pages/Admin/LoanManagement/AllLoanRepaymentByMember";
import LoanRepaymentByMemberSearchPage from "../pages/Admin/LoanManagement/LoanRepaymentByMemberSearchPage";
import { SingleLoanRepaymentBreakdownByMember } from "../pages/Admin/LoanManagement/SingleLoanRepaymentBreakdownbyMember";
import ContributionCategory from "../pages/Admin/Contribution/contribution-category";
import PublicMemberRegistrationPage from "../pages/Admin/MemberRegistration/PublicMemberRegistrationPage";
import Notifications from "../pages/Admin/Notifications/Notifications";
import NotificationDetails from "../pages/Admin/Notifications/NotificationDetails";
import MemberNotifications from "../pages/Members/Notifications/Notifications";
import MemberNotificationDetails from "../pages/Members/Notifications/NotificationDetails";
import SmsHistory from "../pages/Admin/Reports/SmsHistory";
import ModuleInDevelopment from "../pages/Admin/Common/ModuleInDevelopment";
import AuditLogPage from "../pages/Admin/AuditLog/AuditLogPage";
import InvestorDashboard from "../pages/Investor/Home/InvestorDashboard";
import InvestorOnboardingPage from "../pages/Investor/Onboarding/InvestorOnboardingPage";
import InvestorOnboardingVerificationPage from "../pages/Investor/Onboarding/InvestorOnboardingVerificationPage";
import InvestorKycPage from "../pages/Investor/Kyc/InvestorKycPage";
import InvestorInvestmentsPage from "../pages/Investor/Investments/InvestorInvestmentsPage";
import InvestorMyRequestsPage from "../pages/Investor/Investments/InvestorMyRequestsPage";
import InvestorInvestmentRequestDetailPage from "../pages/Investor/Investments/InvestorInvestmentRequestDetailPage";
import InvestorInvestmentDetailPage from "../pages/Investor/Investments/InvestorInvestmentDetailPage";
import InvestmentPaymentConfirmation from "../pages/Investor/Investments/InvestmentPaymentConfirmation";
import MarketplacePaymentConfirmation from "../pages/Investor/Marketplace/MarketplacePaymentConfirmation";
import InvestorMarketplacePage from "../pages/Investor/Marketplace/InvestorMarketplacePage";
import InvestorMarketplaceProductDetailPage from "../pages/Investor/Marketplace/InvestorMarketplaceProductDetailPage";
import InvestorMarketplaceOrderDetailPage from "../pages/Investor/Marketplace/InvestorMarketplaceOrderDetailPage";
import InvestorRequestsPage from "../pages/Investor/Requests/InvestorRequestsPage";
import InvestorRequestDetailPage from "../pages/Investor/Requests/InvestorRequestDetailPage";
import CooperativeRequestPage from "../pages/Investor/Requests/CooperativeRequestPage";
import RealEstateRequestPage from "../pages/Investor/Requests/RealEstateRequestPage";
import InvestorProfilePage from "../pages/Investor/Profile/InvestorProfilePage";
import InvestorNotificationsPage from "../pages/Investor/Notifications/InvestorNotificationsPage";
import InvestorNotificationDetailsPage from "../pages/Investor/Notifications/InvestorNotificationDetailsPage";
import InvestorPortalDashboard from "../pages/Admin/InvestorPortal/Dashboard/InvestorPortalDashboard";
import OpportunitiesListPage from "../pages/Admin/InvestorPortal/Investments/OpportunitiesListPage";
import OpportunityFormPage from "../pages/Admin/InvestorPortal/Investments/OpportunityFormPage";
import OpportunityDetailPage from "../pages/Admin/InvestorPortal/Investments/OpportunityDetailPage";
import InvestmentRequestsPage from "../pages/Admin/InvestorPortal/Investments/InvestmentRequestsPage";
import InvestmentRequestDetailPage from "../pages/Admin/InvestorPortal/Investments/InvestmentRequestDetailPage";
import InvestorAccountsListPage from "../pages/Admin/InvestorPortal/Investors/InvestorAccountsListPage";
import InvestorAccountDetailPage from "../pages/Admin/InvestorPortal/Investors/InvestorAccountDetailPage";
import KycReviewsListPage from "../pages/Admin/InvestorPortal/Kyc/KycReviewsListPage";
import KycReviewDetailPage from "../pages/Admin/InvestorPortal/Kyc/KycReviewDetailPage";
import ServiceRequestsListPage from "../pages/Admin/InvestorPortal/Requests/ServiceRequestsListPage";
import CooperativeRequestsPage from "../pages/Admin/InvestorPortal/Requests/CooperativeRequestsPage";
import RealEstateRequestsPage from "../pages/Admin/InvestorPortal/Requests/RealEstateRequestsPage";
import ServiceRequestDetailPage from "../pages/Admin/InvestorPortal/Requests/ServiceRequestDetailPage";
import InvestmentParticipantsPage from "../pages/Admin/InvestorPortal/Participants/InvestmentParticipantsPage";
import MarketplaceDashboard from "../pages/Admin/InvestorPortal/Marketplace/MarketplaceDashboard";
import ProductsListPage from "../pages/Admin/InvestorPortal/Marketplace/ProductsListPage";
import ProductFormPage from "../pages/Admin/InvestorPortal/Marketplace/ProductFormPage";
import ProductDetailPage from "../pages/Admin/InvestorPortal/Marketplace/ProductDetailPage";
import CategoriesPage from "../pages/Admin/InvestorPortal/Marketplace/CategoriesPage";
import OrdersListPage from "../pages/Admin/InvestorPortal/Marketplace/OrdersListPage";
import OrderDetailPage from "../pages/Admin/InvestorPortal/Marketplace/OrderDetailPage";
import TestimonialsPage from "../pages/Admin/InvestorPortal/Website/TestimonialsPage";

export const routeList = [
  {
    children: [
      {
        component: Home,
        exact: true,
        name: "Home",
        path: "/super_admin/dashboard",
        protected: true,
      },
      {
        component: AuditLogPage,
        exact: true,
        name: "Audit log",
        path: "/super_admin/audit_log",
        protected: true,
      },
      {
        component: StaffProfile,
        exact: true,
        name: "Profile",
        path: "/super_admin/profile",
        protected: true,
      },
      {
        component: Notifications,
        exact: true,
        name: "Notifications",
        path: "/super_admin/notifications",
        protected: true,
      },
      {
        component: NotificationDetails,
        exact: true,
        name: "Notification Details",
        path: "/super_admin/notifications/:id",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Home",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: BatchUpload,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration/batch_upload",
        protected: true,
      },
      {
        component: ChangeBranch,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration/change_branch/:id",
        protected: true,
      },
      {
        component: SuspendStaff,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration/suspend_staff/:id",
        protected: true,
      },
      {
        component: EditStaff,
        exact: true,
        name: "Edit Staff",
        path: "/super_admin/staff_registration/view_staff/:id/edit",
        protected: true,
      },
      {
        component: ViewSingleStaff,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration/view_staff/:id",
        protected: true,
      },
      {
        component: ViewStaff,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration/view_staff",
        protected: true,
      },
      {
        component: StaffRegistrationHome,
        exact: true,
        name: "Home",
        path: "/super_admin/staff_registration",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Staff Registration",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberBatchUpload,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/batch_upload",
        protected: true,
      },
      {
        component: ChangeBranchMember,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members/:id/change_branch",
        protected: true,
      },
      {
        component: PendingMember,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/pending_member",
        protected: true,
      },
      {
        component: ViewSingleMember,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members/:id",
        protected: true,
      },
      {
        component: MemberHistory,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members/:id/history",
        protected: true,
      },
      {
        component: SuspendMember,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members/:id/suspend",
        protected: true,
      },
      {
        component: UpdateMember,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members/:id/update",
        protected: true,
      },
      {
        component: ViewMembers,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/members",
        protected: true,
      },
      {
        component: ArchivedMembers,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/archived_members",
        protected: true,
      },
      {
        component: MemberExitRequests,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/exit_requests",
        protected: true,
      },
      {
        component: ExitedMembers,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management/exited_members",
        protected: true,
      },
      {
        component: MemberRegHome,
        exact: true,
        name: "Home",
        path: "/super_admin/member_management",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Member Registration",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: CommunicationSummary,
        exact: true,
        name: "Home",
        path: "/super_admin/communication/summary",
        protected: true,
      },
      {
        component: GroupManagement,
        exact: true,
        name: "Home",
        path: "/super_admin/communication/group_management",
        protected: true,
      },
      {
        component: ViewGroup,
        exact: true,
        name: "Home",
        path: "/super_admin/communication/group_management/:groupId",
        protected: true,
      },
      {
        component: AddMembersToGroup,
        exact: true,
        name: "Home",
        path:
          "/super_admin/communication/group_management/:groupId/add_members",
        protected: true,
      },
      {
        component: Communications,
        exact: true,
        name: "Home",
        path: "/super_admin/communication",
        protected: true,
      },
      {
        component: CommunicationMessageDetail,
        exact: true,
        name: "Home",
        path: "/super_admin/communication/messages/:id",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Communications",
    protected: true,
  },
  {
    children: [
      {
        component: ContributionCategory,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/contribution-category",
        protected: true,
      },
      {
        component: Record_ContributionMain,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/record_contribution/:id",
        protected: true,
      },
      {
        component: Record_ContributionMain,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/record_contribution/",
        protected: true,
      },
      {
        component: Contribution_HistoryDetail,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/contribution_history/:id",
        protected: true,
      },
      {
        component: Contribution_History,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/contribution_history",
        protected: true,
      },
      {
        component: Contribution_HistoryV2,
        exact: true,
        name: "Contribution Summary",
        path: "/super_admin/contribution/contribution_history_v2",
        protected: true,
      },
      {
        component: WithdrawalRequests,
        exact: true,
        name: "Withdrawal Requests",
        path: "/super_admin/contribution/withdrawal_requests",
        protected: true,
      },
      {
        component: BranchSettlementWallet,
        exact: true,
        name: "Branch settlement wallet",
        path: "/super_admin/contribution/branch_settlement_wallet",
        protected: true,
      },
      {
        component: BankTransferConfirmations,
        exact: true,
        name: "Bank transfer confirmations",
        path: "/super_admin/contribution/bank_transfer_confirmations",
        protected: true,
      },
      {
        component: OnlinePendingPayments,
        exact: true,
        name: "Online payment requery",
        path: "/super_admin/contribution/online_payment_requery",
        protected: true,
      },
      {
        component: Create_Contribution,
        exact: true,
        name: "Home",
        path: "/super_admin/contribution/create_contribution",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Contribution",
    // path: "/",
    protected: true,
  },
  {
    children: [
      // {
      //   component: RecordLoanRepayment,
      //   exact: true,
      //   name: "Home",
      //   path: "/super_admin/loan_management/record_loan_repayment",
      //   protected: true,
      // },
      {
        component: SingleLoanRepaymentBreakdownByMember,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/loan_repayment/:loanRequestId",
        protected: true,
      },
      // {
      //   component: LoanRepaymentMemberBreakdown,
      //   exact: true,
      //   name: "Home",
      //   path: "/super_admin/loan_management/loan_repayment/:memberId",
      //   protected: true,
      // },
      {
        component: LoanRepayment,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/loan_repayment",
        protected: true,
      },
      {
        component: LoanStatus,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/loan_status",
        protected: true,
      },
      {
        component: LoanRepaymentRecord,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/record_loan_repayment/:id",
        protected: true,
      },
      {
        component: NewApplication,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/new_application",
        protected: true,
      },
      {
        component: AdminLoanCalculator,
        exact: true,
        name: "Loan Calculator",
        path: "/super_admin/loan_management/loan_calculator",
        protected: true,
      },
      {
        component: RecordExistingLoanNew,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/record_existing_loan/new",
        protected: true,
      },
      {
        component: RecordExistingLoanDetail,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/record_existing_loan/:loanId",
        protected: true,
      },
      {
        component: RecordExistingLoan,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/record_existing_loan",
        protected: true,
      },
      {
        component: LoanType,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/loan_type",
        protected: true,
      },
      {
        component: LoanRepaymentByMemberSearchPage,
        exact: true,
        name: "Home",
        path: "/super_admin/loan_management/repayment_by_member",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Contribution",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: FineSettings,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/fine_settings",
        protected: true,
      },
      {
        component: NewFine,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/fine_settings/new",
        protected: true,
      },
      {
        component: EditFine,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/fine_settings/edit/:id",
        protected: true,
      },
      {
        component: SettingEditNewRegistrationFee,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/member_registration_fee/:id",
        protected: true,
      },
      {
        component: SettingMemberRegistrationFee,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/member_registration_fee",
        protected: true,
      },
      {
        component: SocietyBankInfo,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/society_bank_info",
        protected: true,
      },
      {
        component: NewBankInfo,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/society_bank_info/new",
        protected: true,
      },
      {
        component: LoanApplicationSetting,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/loan_application_settings",
        protected: true,
      },
      {
        component: SettingRoleManagement,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/role_management",
        protected: true,
      },
      {
        component: NewRole,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/role_management/new",
        protected: true,
      },
      {
        component: EditRole,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/role_management/:roleId/edit",
        protected: true,
      },
      {
        component: CompanyPrefix,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/company_prefix",
        protected: true,
      },
      {
        component: EditCompanyPrefix,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/company_prefix/:id",
        protected: true,
      },
      {
        component: SettingEditBranch,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/branch_management/:id",
        protected: true,
      },
      {
        component: SettingBranch,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/branch_management",
        protected: true,
      },
      {
        component: MemberSlotCapacity,
        exact: true,
        name: "Member slot capacity",
        path: "/super_admin/settings/member_slot_capacity",
        protected: true,
      },
      {
        // The sidebar's Settings group points at /super_admin/settings, which had no page of its own.
        component: SettingsIndexRedirect,
        exact: true,
        name: "Settings",
        path: "/super_admin/settings",
        protected: true,
      },
      {
        component: ConfigurationHome,
        exact: true,
        name: "Home",
        path: "/super_admin/settings/portal_settings",
        protected: true,
      },
      {
        component: SupportSettings,
        exact: true,
        name: "Support Settings",
        path: "/super_admin/settings/support_settings",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Configuration And Settings",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: EditEventCalendar,
        exact: true,
        name: "Home",
        path: "/super_admin/event_calendar/:id",
        protected: true,
      },
      {
        component: EventCalendarCreate,
        exact: true,
        name: "Home",
        path: "/super_admin/event_calendar/create",
        protected: true,
      },
      {
        component: EventCalendar,
        exact: true,
        name: "Home",
        path: "/super_admin/event_calendar",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Event Calendar",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: AttendanceHistory,
        exact: true,
        name: "Home",
        path: "/super_admin/attendance/history",
        protected: true,
      },
      {
        component: MemberAttendanceHistory,
        exact: true,
        name: "Home",
        path: "/super_admin/attendance/history/:memberId",
        protected: true,
      },
      {
        component: AttendanceHome,
        exact: true,
        name: "Home",
        path: "/super_admin/attendance",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Attendance",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: AutomatedBirthdayHome,
        exact: true,
        name: "Home",
        path: "/super_admin/automated_birthday",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Automated Birthday ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: StaffTransactionHistory,
        exact: true,
        name: "Transaction History",
        path: "/super_admin/transaction_history",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Financial Management",
    protected: true,
  },
  {
    children: [
      {
        component: SmsHistory,
        exact: true,
        name: "SMS History",
        path: "/super_admin/reports/sms_history",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Reporting & Analytics",
    protected: true,
  },
  {
    children: [
      {
        component: ModuleInDevelopment,
        exact: true,
        name: "Module in development",
        path: "/super_admin/modules/in-development/:moduleKey",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Module in development",
    protected: true,
  },
  {
    children: [
      {
        component: InvestorPortalDashboard,
        exact: true,
        name: "Investment Hub Overview",
        path: "/super_admin/investor_portal/dashboard",
        protected: true,
      },
      {
        component: OpportunitiesListPage,
        exact: true,
        name: "Investment Opportunities",
        path: "/super_admin/investor_portal/investments/opportunities",
        protected: true,
      },
      {
        component: OpportunityFormPage,
        exact: true,
        name: "Create Investment Opportunity",
        path: "/super_admin/investor_portal/investments/opportunities/new",
        protected: true,
      },
      {
        component: OpportunityFormPage,
        exact: true,
        name: "Edit Investment Opportunity",
        path: "/super_admin/investor_portal/investments/opportunities/:opportunityId/edit",
        protected: true,
      },
      {
        component: OpportunityDetailPage,
        exact: true,
        name: "Investment Opportunity Detail",
        path: "/super_admin/investor_portal/investments/opportunities/:opportunityId",
        protected: true,
      },
      {
        component: InvestmentRequestsPage,
        exact: true,
        name: "Investment Requests",
        path: "/super_admin/investor_portal/investments/requests",
        protected: true,
      },
      {
        component: InvestmentRequestDetailPage,
        exact: true,
        name: "Investment Request Detail",
        path: "/super_admin/investor_portal/investments/requests/:requestId",
        protected: true,
      },
      {
        component: InvestorAccountsListPage,
        exact: true,
        name: "Investor Accounts",
        path: "/super_admin/investor_portal/investors",
        protected: true,
      },
      {
        component: KycReviewsListPage,
        exact: true,
        name: "KYC Reviews",
        path: "/super_admin/investor_portal/investors/kyc",
        protected: true,
      },
      {
        component: KycReviewDetailPage,
        exact: true,
        name: "KYC Review Detail",
        path: "/super_admin/investor_portal/investors/kyc/:submissionId",
        protected: true,
      },
      // Legacy notification deep-link (older staffKycReview URLs)
      {
        component: KycReviewDetailPage,
        exact: true,
        name: "KYC Review Detail (legacy)",
        path: "/super_admin/investor_portal/kyc/:submissionId",
        protected: true,
      },
      {
        component: InvestorAccountDetailPage,
        exact: true,
        name: "Investor Account Detail",
        path: "/super_admin/investor_portal/investors/:investorId",
        protected: true,
      },
      {
        component: ServiceRequestsListPage,
        exact: true,
        name: "Service Requests",
        path: "/super_admin/investor_portal/requests",
        protected: true,
      },
      {
        component: CooperativeRequestsPage,
        exact: true,
        name: "Cooperative Requests",
        path: "/super_admin/investor_portal/requests/cooperative",
        protected: true,
      },
      {
        component: RealEstateRequestsPage,
        exact: true,
        name: "Real Estate Requests",
        path: "/super_admin/investor_portal/requests/real-estate",
        protected: true,
      },
      {
        component: ServiceRequestDetailPage,
        exact: true,
        name: "Service Request Detail",
        path: "/super_admin/investor_portal/requests/:requestId",
        protected: true,
      },
      {
        component: InvestmentParticipantsPage,
        exact: true,
        name: "Investment Participants",
        path: "/super_admin/investor_portal/participants",
        protected: true,
      },
      {
        component: MarketplaceDashboard,
        exact: true,
        name: "Marketplace Overview",
        path: "/super_admin/investor_portal/marketplace/dashboard",
        protected: true,
      },
      {
        component: ProductsListPage,
        exact: true,
        name: "Marketplace Products",
        path: "/super_admin/investor_portal/marketplace/products",
        protected: true,
      },
      {
        component: ProductFormPage,
        exact: true,
        name: "Create Marketplace Product",
        path: "/super_admin/investor_portal/marketplace/products/new",
        protected: true,
      },
      {
        component: ProductFormPage,
        exact: true,
        name: "Edit Marketplace Product",
        path: "/super_admin/investor_portal/marketplace/products/:productSlug/edit",
        protected: true,
      },
      {
        component: ProductDetailPage,
        exact: true,
        name: "Marketplace Product Detail",
        path: "/super_admin/investor_portal/marketplace/products/:productSlug",
        protected: true,
      },
      {
        component: TestimonialsPage,
        exact: true,
        name: "Website Testimonials",
        path: "/super_admin/investor_portal/website/testimonials",
        protected: true,
      },
      {
        component: CategoriesPage,
        exact: true,
        name: "Marketplace Categories",
        path: "/super_admin/investor_portal/marketplace/categories",
        protected: true,
      },
      {
        component: OrdersListPage,
        exact: true,
        name: "Marketplace Orders",
        path: "/super_admin/investor_portal/marketplace/orders",
        protected: true,
      },
      {
        component: OrderDetailPage,
        exact: true,
        name: "Marketplace Order Detail",
        path: "/super_admin/investor_portal/marketplace/orders/:orderId",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Investment Hub",
    protected: true,
  },
  {
    children: [
      {
        component: MemberHome,
        exact: true,
        name: "Home",
        path: "/member/dashboard",
        protected: true,
      },
      {
        component: MemberBirthdays,
        exact: true,
        name: "Birthdays",
        path: "/member/birthdays",
        protected: true,
      },
      {
        component: MemberProfile,
        exact: true,
        name: "Profile",
        path: "/member/profile",
        protected: true,
      },
      {
        component: EditMemberProfile,
        exact: true,
        name: "Edit Profile",
        path: "/member/profile/edit",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Automated Birthday ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberLoanRepayment,
        exact: true,
        name: "Home",
        path: "/member/loan_management/loan_repayment",
        protected: true,
      },
      {
        component: MemberLoanRepaymentBreakdown,
        exact: true,
        name: "Loan Repayment Breakdown",
        path: "/member/loan_management/repayment/:loanRequestId",
        protected: true,
      },
      {
        component: MemberLoanRepaymentPay,
        exact: true,
        name: "Pay Loan Repayment",
        path: "/member/loan_management/loan_repayment/pay/:repaymentId",
        protected: true,
      },
      {
        component: MemberLoanStatus,
        exact: true,
        name: "Home",
        path: "/member/loan_management/loan_status",
        protected: true,
      },
      {
        component: GuarantorRequests,
        exact: true,
        name: "Guarantor Requests",
        path: "/member/loan_management/guarantor_requests",
        protected: true,
      },
      {
        component: LoanApplication,
        exact: true,
        name: "Home",
        path: "/member/loan_management/application",
        protected: true,
      },
      {
        component: LoanCalculationResult,
        exact: true,
        name: "Home",
        path: "/member/loan_management/calculation",
        protected: true,
      },
      {
        component: LoanManagement,
        exact: true,
        name: "Home",
        path: "/member/loan_management",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Automated Birthday ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberCreateContribution,
        exact: true,
        name: "Home",
        path: "/member/contribution/create",
        protected: true,
      },
      {
        component: MemberLateContribution,
        exact: true,
        name: "Home",
        path: "/member/contribution/late_contribution",
        protected: true,
      },
      {
        component: MemberUpcomingContribution,
        exact: true,
        name: "Home",
        path: "/member/contribution/upcoming_contribution",
        protected: true,
      },

      {
        component: MemberContribution,
        exact: true,
        name: "Home",
        path: "/member/contribution",
        protected: true,
      },
      {
        component: RecordContribution,
        exact: true,
        name: "Record Contribution",
        path: "/member/contribution/record",
        protected: true,
      },
      {
        component: PaymentConfirmation,
        exact: true,
        name: "Payment Confirmation",
        path: "/member/payment/confirmation",
        protected: false, // Public route - no authentication required (for mobile Paystack redirects)
      },
      {
        component: AlatpayCheckout,
        exact: true,
        name: "ALATPay Checkout",
        path: "/member/payment/alatpay",
        protected: false,
      },
      {
        component: MemberTransactionHistory,
        exact: true,
        name: "Transaction History",
        path: "/member/transaction_history",
        protected: true,
      },
      {
        component: MemberCommunication,
        exact: true,
        name: "Messages",
        path: "/member/communication",
        protected: true,
      },
      {
        component: MemberCommunicationDetail,
        exact: true,
        name: "Message Detail",
        path: "/member/communication/messages/:id",
        protected: true,
      },
      {
        component: MemberSupport,
        exact: true,
        name: "Support",
        path: "/member/support",
        protected: true,
      },
      {
        component: MemberNotifications,
        exact: true,
        name: "Notifications",
        path: "/member/notifications",
        protected: true,
      },
      {
        component: MemberNotificationDetails,
        exact: true,
        name: "Notification Details",
        path: "/member/notifications/:id",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Contribution ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberEvent,
        exact: true,
        name: "Home",
        path: "/member/event",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Contribution ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberAttendance,
        exact: true,
        name: "Home",
        path: "/member/attendance",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Attendance ",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: MemberEminutesList,
        exact: true,
        name: "E-Minutes",
        path: "/member/eminutes",
        protected: true,
      },
      {
        component: MemberEminuteDetail,
        exact: true,
        name: "E-Minute Detail",
        path: "/member/eminutes/:id",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "E-Minutes",
    protected: true,
  },
  {
    children: [
      {
        component: EminuteHome,
        exact: true,
        name: "Home",
        path: "/super_admin/eminutes",
        protected: true,
      },
      {
        component: NewEminute,
        exact: true,
        name: "Home",
        path: "/super_admin/eminutes/new",
        protected: true,
      },
      {
        component: EminutePage,
        exact: true,
        name: "Home",
        path: "/super_admin/eminutes/:id",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Member Registration",
    // path: "/",
    protected: true,
  },
  {
    children: [
      {
        component: EventCalendar,
        exact: true,
        name: "Event Calendar",
        path: "/super_admin/event_calendar",
        protected: true,
      },
      {
        component: EventCalendarCreate,
        exact: true,
        name: "Create Event",
        path: "/super_admin/event_calendar/create",
        protected: true,
      },
      {
        component: EditEventCalendar,
        exact: true,
        name: "Edit Event",
        path: "/super_admin/event_calendar/:id/edit",
        protected: true,
      },
    ],
    component: Home,
    exact: true,
    name: "Event Calendar",
    // path: "/",
    protected: true,
  },
  {
    component: PublicMemberRegistrationPage,
    exact: true,
    name: "Public Member Registration",
    path: "/member-signup",
    protected: false,
  },
  {
    children: [
      {
        component: InvestorDashboard,
        exact: true,
        name: "Investor Dashboard",
        path: "/invest/dashboard",
        protected: true,
      },
      {
        component: InvestorOnboardingPage,
        exact: true,
        name: "Investor Onboarding",
        path: "/invest/onboarding",
        protected: true,
      },
      {
        component: InvestorOnboardingVerificationPage,
        exact: true,
        name: "Investor Onboarding Verification",
        path: "/invest/onboarding/verification",
        protected: true,
      },
      {
        component: InvestorKycPage,
        exact: true,
        name: "Investor KYC",
        path: "/invest/kyc",
        protected: true,
      },
      {
        component: InvestorNotificationsPage,
        exact: true,
        name: "Investor Notifications",
        path: "/invest/notifications",
        protected: true,
      },
      {
        component: InvestorNotificationDetailsPage,
        exact: true,
        name: "Investor Notification Details",
        path: "/invest/notifications/:id",
        protected: true,
      },
      {
        component: InvestorInvestmentsPage,
        exact: true,
        name: "Investor Investments",
        path: "/invest/investments",
        protected: true,
      },
      {
        component: InvestmentPaymentConfirmation,
        exact: true,
        name: "Investment Payment Confirmation",
        path: "/invest/payment/confirmation",
        protected: false,
      },
      {
        component: MarketplacePaymentConfirmation,
        exact: true,
        name: "Marketplace Payment Confirmation",
        path: "/invest/marketplace/payment/confirmation",
        protected: false,
      },
      {
        component: InvestorRequestsPage,
        exact: true,
        name: "Investor Requests",
        path: "/invest/requests",
        protected: true,
      },
      {
        component: InvestorRequestDetailPage,
        exact: true,
        name: "Investor Request Detail",
        path: "/invest/requests/:requestId",
        protected: true,
      },
      {
        component: InvestorMyRequestsPage,
        exact: true,
        name: "Investor My Requests Legacy",
        path: "/invest/my-requests",
        protected: true,
      },
      {
        component: InvestorInvestmentRequestDetailPage,
        exact: true,
        name: "Investor Investment Request Detail Legacy",
        path: "/invest/my-requests/:requestId",
        protected: true,
      },
      {
        component: InvestorInvestmentDetailPage,
        exact: true,
        name: "Investor Investment Detail",
        path: "/invest/investments/:opportunityId",
        protected: true,
      },
      {
        component: InvestorMarketplacePage,
        exact: true,
        name: "Investor Marketplace",
        path: "/invest/marketplace",
        protected: true,
      },
      {
        component: InvestorMarketplaceOrderDetailPage,
        exact: true,
        name: "Investor Marketplace Order Detail",
        path: "/invest/marketplace/orders/:orderNumber",
        protected: true,
      },
      {
        component: InvestorMarketplaceProductDetailPage,
        exact: true,
        name: "Investor Marketplace Product Detail",
        path: "/invest/marketplace/:productId",
        protected: true,
      },
      {
        component: CooperativeRequestPage,
        exact: true,
        name: "Cooperative Request",
        path: "/invest/cooperative-request",
        protected: true,
      },
      {
        component: RealEstateRequestPage,
        exact: true,
        name: "Real Estate Request",
        path: "/invest/real-estate",
        protected: true,
      },
      {
        component: InvestorProfilePage,
        exact: true,
        name: "Investor Profile",
        path: "/invest/profile",
        protected: true,
      },
    ],
    component: InvestorDashboard,
    exact: true,
    name: "Investor",
    protected: true,
  },
];
